import { Injectable } from '@angular/core';
import { NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

function padNumber(value: any): string {
    if (!isNaN(value) && value !== null) {
        return `0${value}`.slice(-2);
    } else {
        return '';
    }
}

@Injectable()
export class NgbDateCustomParserFormatter extends NgbDateParserFormatter {
    parse(value: string): NgbDateStruct | null {
        if (value) {
            const dateParts: any = value.trim().split('/');

            const dateObj: any = { day: <any>null, month: <any>null, year: <any>null };
            const dateLabels = Object.keys(dateObj);

            dateParts.forEach((datePart: any, idx: any) => {
                dateObj[dateLabels[idx]] = parseInt(datePart, 10) || <any>null;
            });
            return dateObj;
        }
        return null;
    }

    format(date: NgbDateStruct | null): string {
        return date ?
            `${padNumber(date.day)}/${padNumber(date.month)}/${date.year || ''}` :
            '';
    }
}
